(ns frontend.ui.component.chart.utils
  (:require
   [common.number-utils :as nu]
   [common.util :as cu]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.utils :as fu]))

(defn ^{:jsdoc ["@nocollapse"]} float-tooltip-formatter
  [js-data-point suffix divide]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)
        y (fu/aget-in point ["y"])
        series-name (or (:key point)
                        (fu/aget-in point ["series" "name"]))
        color (or (:color point)
                  (fu/aget-in point ["color"]))]
    (str "<span style=\"color:"
         color
         "\">\u25CF</span> "
         "<strong>"
         series-name
         "</strong>  "
         (if (number? y)
           (str (when (neg? y)
                  "-")
                (fu/number-string->thousand-separators
                 (fu/format "%.1f" (fu/round (/ (Math/abs y) divide) 1))
                 ","
                 ".")
                suffix)
           y)
         "<br>")))

(defn ^{:jsdoc ["@nocollapse"]} float-tooltip-formatter-dynamic-decimals                            ;;TODO refactor
  [js-data-point suffix divide decimals]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)
        y (fu/aget-in point ["y"])
        divider (if (= "auto" divide) (util/resolve-automatic-divider y) divide)
        suffix (if (= "auto" divide) (case divider
                                       1 ""
                                       1000 "k"
                                       1000000 "M"
                                       "") suffix)
        series-name (or (:key point)
                        (fu/aget-in point ["series" "name"]))
        color (or (:color point)
                  (fu/aget-in point ["color"]))
        decimals (or decimals 2)
        formatted-number (str (.toFixed (fu/round (/ y divider) decimals) decimals))]
    (str "<span style=\"color:"
         color
         "\">\u25CF</span> "
         "<strong>"
         series-name
         "</strong>  "
         (if (number? y)
           (str (fu/number-string->thousand-separators
                 formatted-number
                 ","
                 ".")
                suffix)
           y)
         "<br>")))

(defn ^{:jsdoc ["@nocollapse"]} generic-label-formatter
  [js-data-point divide decimals suffix]
  (let [data (js->clj js-data-point
                      :keywordize-keys
                      true)
        y (:y data)
        decimals (or decimals 2)
        divider (cond (= "auto" divide)
                      (util/resolve-automatic-divider y)
                      (number? divide)
                      divide
                      :else
                      1)]
    (str (fu/number-string->thousand-separators
          (str (.toFixed (fu/round (/ y divider) decimals) decimals))
          ","
          ".") suffix)))

(defn ^{:jsdoc ["@nocollapse"]} meur-label-formatter
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "" (util/->int-million (:y data))))))

(defn ^{:jsdoc ["@nocollapse"]} pie-me-label-formatter-no-division
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           (fu/format "%.1f" (fu/round (:y data) 1))
           "M€"))))

(defn ^{:jsdoc ["@nocollapse"]} pie-float-label-formatter-no-division
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           (fu/format "%.1f" (fu/round (:y data) 1))))))

(defn ^{:jsdoc ["@nocollapse"]} pie-float-label-formatter-no-division-with-%
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           #_(fu/round (:y data) 1)
           #_"<br><span>&nbsp;&nbsp;&nbsp;&nbsp;"
           (util/->percent-1-decimal (/ (:percentage data) 100))
           #_"</span>"))))



(defn ^{:jsdoc ["@nocollapse"]} pie-float-label-formatter-divide-m
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           (fu/format "%.1f" (fu/round (/ (:y data) 1000000) 1))))))

(defn ^{:jsdoc ["@nocollapse"]} pie-float-label-formatter-with-names-divide-m
  []
  (this-as js-data-point
           (let [data        (js->clj js-data-point :keywordize-keys true)
                 point-name  (or (some-> js-data-point .-point .-name)
                                 (get data :name))
                 raw-series-name   (some-> js-data-point .-series .-name)
                 series-name (when (and raw-series-name (not (re-matches #"Series \d+" raw-series-name)))
                               raw-series-name)
                 label-name  (or point-name series-name "")
                 value-m     (fu/round (/ (:y data) 1000000) 1)]
             (str
              (when (seq label-name)
                (str "<span>" label-name "</span> "))
              "€"
              (fu/format "%.1f" value-m)
              "m"))))

(defn ^{:jsdoc ["@nocollapse"]} pie-me-label-formatter-no-division-with-%
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           (fu/round (:y data) 1)
           "M€"
           "<br><span>&nbsp;&nbsp;&nbsp;&nbsp;"
           (util/->percent-1-decimal (/ (:percentage data) 100))
           "</span>"))))

(defn ^{:jsdoc ["@nocollapse"]} pie-me-label-formatter-divide-m
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           (fu/format "%1.f" (fu/round (/ (:y data) 1000000) 1))
           "M€"))))

(defn ^{:jsdoc ["@nocollapse"]} pie-%-label-formatter-no-division
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           (fu/format "%.1f" (fu/round (:percentage data) 1))
           "%"))))

(defn ^{:jsdoc ["@nocollapse"]} pie-%-label-formatter-no-letters-0-decimals
  []
  (this-as js-data-point
           (let [data (js->clj js-data-point
                               :keywordize-keys
                               true)]
             (str "<span "
                  ">"
                  "</span> "
                  (fu/format "%.0f" (fu/round (:percentage data) 0))
                  "%"))))

(defn ^{:jsdoc ["@nocollapse"]} pie-float-formatter
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           (fu/round (:y data) 1)))))

(defn ^{:jsdoc ["@nocollapse"]} pie-float-formatter-0-decimals
  []
  (this-as js-data-point
           (let [data (js->clj js-data-point
                               :keywordize-keys
                               true)]
             (str (fu/round (:y data) 0)))))

(defn ^{:jsdoc ["@nocollapse"]} pie-m2-and-%-formatter
  []
  (this-as js-data-point
    (let [data (js->clj js-data-point
                        :keywordize-keys
                        true)]
      (str "<span "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters (:colorIndex data))
           ") </span> "
           (fu/format-with-separators-read-only (:y data) 0 false 0 true)))))

(defn ^{:jsdoc ["@nocollapse"]} meur-formatter
  []
  (this-as js-data-point
    (float-tooltip-formatter js-data-point " M€" 1)))

(defn ^{:jsdoc ["@nocollapse"]} keur-formatter
  []
  (this-as js-data-point
    (float-tooltip-formatter js-data-point " k€" 1)))

(defn ^{:jsdoc ["@nocollapse"]} meur-formatter-divide-m
  []
  (this-as js-data-point
    (float-tooltip-formatter js-data-point " M€" 1000000)))

(defn ^{:jsdoc ["@nocollapse"]} pct-formatter
  []
  (this-as js-data-point
    (float-tooltip-formatter js-data-point "%" 1)))

(defn ^{:jsdoc ["@nocollapse"]} mult-to-pct-formatter
  []
  (this-as js-data-point
    (float-tooltip-formatter js-data-point "%" 0.01)))

(defn ^{:jsdoc ["@nocollapse"]} mult-formatter
  []
  (this-as js-data-point
    (float-tooltip-formatter js-data-point "x" 1)))

(defn ^{:jsdoc ["@nocollapse"]} float-axis-formatter
  [js-data-point _suffix]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)]
    (if (:isFirst point)
      "0"
      (str (util/->percent-1-decimal (:value point))))))

(defn ^{:jsdoc ["@nocollapse"]} float-axis-formatter-0-decimals
  [js-data-point _suffix]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)]
    (if (:isFirst point)
      "0"
      (str (util/->percent-0-decimal (:value point))))))

(defn ^{:jsdoc ["@nocollapse"]} mult-axis-formatter
  [js-data-point _suffix]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)]
    (if (zero? (:value point))
      "0"
      (str (util/->multiple (:value point))))))

(defn ^{:jsdoc ["@nocollapse"]} mult-axis-formatter-without-x
  [js-data-point _suffix]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)]
    (if (zero? (:value point))
      "0"
      (str (util/->multiple-without-x (:value point))))))

(defn ^{:jsdoc ["@nocollapse"]} axis-pct-formatter
  []
  (this-as js-data-point
    (float-axis-formatter js-data-point "%")))

(defn ^{:jsdoc ["@nocollapse"]} axis-pct-formatter-0-decimals
  []
  (this-as js-data-point
           (float-axis-formatter-0-decimals js-data-point "%")))

(defn ^{:jsdoc ["@nocollapse"]} float-axis-formatter-divided
  [js-data-point suffix divide]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)]
    (if (zero? (:value point))
      "0"
      (str (util/->int (/ (:value point) divide))
           suffix))))

(defn ^{:jsdoc ["@nocollapse"]} float-axis-formatter-divided-1-decimal
  [js-data-point suffix divide]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)]
    (if (zero? (:value point))
      "0"
      (util/->float-1-decimals suffix (/ (:value point) divide)))))

(defn ^{:jsdoc ["@nocollapse"]} axis-meur-formatter-no-division
  []
  (this-as js-data-point
    (float-axis-formatter-divided js-data-point " M€" 1)))

(defn ^{:jsdoc ["@nocollapse"]} axis-meur-formatter-1-decimal
  []
  (this-as js-data-point
    (float-axis-formatter-divided-1-decimal js-data-point " M€" 1000000)))

(defn ^{:jsdoc ["@nocollapse"]} axis-meur-formatter
  []
  (this-as js-data-point
    (float-axis-formatter-divided js-data-point " M€" 1000000)))

(defn ^{:jsdoc ["@nocollapse"]} axis-million-formatter
  [point]
  (float-axis-formatter-divided point " M" 1000000))

(defn ^{:jsdoc ["@nocollapse"]} axis-keur-formatter
  []
  (this-as js-data-point
    (float-axis-formatter-divided js-data-point " K€" 1000)))

(defn ^{:jsdoc ["@nocollapse"]} axis-thousand-formatter
  [point]
  (float-axis-formatter-divided point " K" 1000))

(defn ^{:jsdoc ["@nocollapse"]} int-axis-formatter
  [js-data-point suffix]
  (let [point (js->clj js-data-point
                       :keywordize-keys
                       true)]
    (str (int (:value point)) suffix)))

(defn ^{:jsdoc ["@nocollapse"]} axis-int-formatter
  []
  (this-as js-data-point
    (int-axis-formatter js-data-point "")))

(defn ^{:jsdoc ["@nocollapse"]} axis-int-eur-formatter
  []
  (this-as js-data-point
    (int-axis-formatter js-data-point "€")))

(defn ^{:jsdoc ["@nocollapse"]} axis-mult-formatter
  []
  (this-as js-data-point
    (mult-axis-formatter js-data-point "x")))

(defn ^{:jsdoc ["@nocollapse"]} pct-value-formatter
  []
  (this-as js-data-point
    (let [point (js->clj js-data-point :keywordize-keys true)]
      (str (util/->percent-1-decimal (/ (:percentage point) 100))))))

(defn ^{:jsdoc ["@nocollapse"]} label-pct-value-formatter
  []
  (this-as js-data-point
    (let [point (js->clj js-data-point :keywordize-keys true)]
      (str (:key point) ": " (util/->percent-1-decimal (/ (:percentage point) 100))))))

(defn config->editable-y-axis-data
  [config]
  (->> config
       :yAxis
       (mapv (fn [axis]
               (vec (concat [(:text (:title axis))]
                            [nil 1 ""]))))))

(defn config->editable-tooltip-data
  [config]
  (->> config
       :series
       (mapv (fn [_]
               (vec [nil 1 ""])))))

(defn resolve-editable-axis-data
  [y-axis-config default-formatter default-title]
  (let [title (first y-axis-config)
        suffix (last y-axis-config)
        decimals (second y-axis-config)
        divider (nth y-axis-config 2)                                                               ;;TODO value "auto" will break
        use-default-title? (cu/blank-value? title)
        use-default-formatter? (and (cu/blank-value? suffix) (cu/blank-value? decimals))
        custom-formatter-fn (fn [label]
                              (util/editable-y-axis-formatter
                               suffix
                               (.-value label)
                               decimals
                               divider))]
    {:y-axis-config (if use-default-formatter? [default-title nil 1 ""] y-axis-config)
     :title-text    (if use-default-title?
                      default-title
                      title)
     :formatter-fn  (if use-default-formatter?
                      default-formatter
                      custom-formatter-fn)}))

(defn resolve-editable-tooltip-data
  [tooltip-config default-formatter]
  (let [suffix (last tooltip-config)
        decimals (first tooltip-config)
        divider (nth tooltip-config 1)
        use-default-formatter? (and (cu/blank-value? suffix) (cu/blank-value? decimals))
        custom-formatter-fn (fn []
                              (this-as js-data-point
                                (float-tooltip-formatter-dynamic-decimals
                                 js-data-point
                                 suffix
                                 divider
                                 decimals)))]
    {:tooltip-config (if use-default-formatter? [nil 1 ""] tooltip-config)
     :formatter-fn   (if use-default-formatter?
                       default-formatter
                       custom-formatter-fn)}))

(defn resolve-series-name
  [custom-name default-name]
  (or custom-name default-name))
